import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import './styles';

const PRINT_TYPES = [
  {
    header: 'SCREEN PRINTING',
    description: 'Screen printing (or silk screen printing) is the industry standard for high-volume printing on textiles.',
    background: require('./screenprint.jpg'),
    list: [
      {
        icon: 'shirt',
        text: '1000+ products available',
      },
      {
        icon: 'palette',
        text: 'Up to 8 print colors',
      },
      {
        icon: 'clock',
        text: 'Typically 3 - 7 day turnarounds',
      },
    ],
  },
  {
    header: 'DTG PRINTING',
    description: 'DTG (direct-to-garment) printing is a digital print technique for full-color, no minimum orders on textiles.',
    background: require('./dtg.jpg'),
    list: [
      {
        icon: 'shirt',
        text: '100+ products available',
      },
      {
        icon: 'palette',
        text: 'Unlimited print colors',
      },
      {
        icon: 'clock',
        text: 'Typically 3 - 5 day turnarounds',
      },
    ],
  },
  {
    header: 'DIGITAL PRINTING',
    description: 'Digital printing is the standard for no minimum, full-color printing on posters and paper products.',
    background: require('./digital.jpg'),
    list: [
      {
        icon: 'frame',
        text: '4 paper types available',
      },
      {
        icon: 'palette',
        text: 'Unlimited print colors',
      },
      {
        icon: 'clock',
        text: '72 hour turnarounds',
      },
    ],
  },
  {
    header: 'SUBLIMATION PRINTING',
    description: 'Sublimation printing is built for full-color, full-wrap printing on drinkware, phone cases.',
    background: require('./sublimation.jpg'),
    list: [
      {
        icon: 'phone',
        text: '20+ products available',
      },
      {
        icon: 'palette',
        text: 'Unlimited print colors',
      },
      {
        icon: 'clock',
        text: '72 hour turnarounds',
      },
    ],
  },
  {
    header: 'EMBROIDERY',
    description: 'Embroidery is a no-minimum, thread-based decoration method for textile products.',
    background: require('./embroidery.jpg'),
    list: [
      {
        icon: 'shirt',
        text: '1000+ products available',
      },
      {
        icon: 'palette',
        text: 'Up to 15 print colors',
      },
      {
        icon: 'clock',
        text: 'Typically 3 - 5 day turnarounds',
      },
    ],
    new: true,
  },
];
// #fdf5ee
export default class PrintTypes extends React.Component {
  static propTypes = {
  }

  state = {}

  render() {
    return (
      <div className="PrintTypes">
        <div className="p-v-2" />
        <div className="p-v-2 computer-only" />
        <div className="ui container">
          <h1 className="m-b-0 center-aligned">
            5 PRINT TYPES,
          </h1>
          <h1 className="m-b-2 m-t-0 center-aligned">
            1000+ PRODUCTS TO PRINT ON
          </h1>
          <div className="p-b-0_5" />
          <div className="ui centered stackable grid">
            <div className="six wide column">
              <p className="center-aligned sub-header m-b-2 fs-3">
                Our print network has the top partners globally to offer best-in-class service for each customization type
              </p>
            </div>
          </div>
          <div className="ui centered grid">
            {_.map(PRINT_TYPES, (printType, index) => (
              <div className="four wide computer four wide tablet six wide mobile column" key={index}>
                <div className="print-card">
                  <div className="background" style={{ backgroundImage: `url(${printType.background})` }} />
                  {printType.new &&
                  <div className="new-label computer-only">
                        NEW
                  </div>
                  }
                  <div className="content p-a-2">
                    <h3 className="m-b-1">{printType.header}</h3>
                    <div className="accent-bar primary-bg-color m-b-1" />
                    <div className="m-b-1 fs-3 computer-only">
                      {printType.description}
                    </div>
                    <div className="print-detail computer-only">
                      {_.map(printType.list, (item, index) => (
                        <div className="item" key={index}>
                          <img src={require(`./${item.icon}.svg`)} className="icon m-r-0_5" />
                          <span className="text">{item.text}</span>
                        </div>
                      ))}
                      <div className="p-t-1">
                        {false && <Link>Learn more <i className="small right chevron icon" /></Link>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="print-image tablet-only mobile-only">
                  <img src={printType.background} alt="print_types" />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="p-v-2" />
        <div className="p-v-2 computer-only" />
        <div className="p-v-2 computer-only" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/HomePage2/PrintTypes/index.jsx